var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import Grid from "../Grid";
import TitleUI from "../Title";
export var VideoPreviewWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  position: relative;\n\n  iframe {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n"], ["\n  width: 100%;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  position: relative;\n\n  iframe {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n"])));
export var Title = styled(TitleUI)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 2rem;\n"], ["\n  margin-bottom: 2rem;\n"])));
export var TextColumn = styled(Grid.Col)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 4rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 4rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3;